import { HeartIcon } from '@heroicons/react/24/outline';
import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full text-white bg-navy-900">
      <div className="max-w-6xl px-6 py-10 mx-auto lg:px-8">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:gap-12 lg:gap-20">
          {/* Organization Info */}
          <div className="flex-1 min-w-[220px]">
            <h3 className="mb-4 text-xl font-semibold font-heading">Blessed Gideon Charity</h3>
            <p className="max-w-md mb-4 text-sm text-gray-300 sm:text-base">
              Focused on poverty alleviation and orphanage care across Africa. We provide food, shelter, education, and hope to vulnerable children and families.
            </p>
            <div className="flex items-center mb-2 text-gray-300">
              <HeartIcon className="w-5 h-5 mr-2 text-coral-400" />
              <span>Empowering Africa's future, one child at a time</span>
            </div>
          </div>
          {/* Contact Info */}
          <div className="flex-1 min-w-[220px]">
            <h4 className="mb-4 text-lg font-semibold font-heading">Contact Us</h4>
            <div className="space-y-2 text-sm text-gray-300 sm:text-base">
              <p>Email: info@blessedgideoncharity.org</p>
              <p>Phone: (587) 703-9270</p>
              <p>Address: 334 South Point Square SW<br />Calgary, Alberta, Canada</p>
            </div>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="flex flex-col gap-4 pt-6 mt-8 border-t border-navy-800 sm:flex-row sm:justify-between sm:items-center">
          <p className="text-xs text-gray-400 sm:text-sm">
            © {currentYear} Blessed Gideon Charity. All rights reserved.
          </p>
          <div className="flex flex-col gap-2 sm:flex-row sm:gap-6">
            <a 
              href="https://cobbycobb.ca/digital" 
              className="text-xs text-gray-400 transition-colors duration-200 hover:text-white sm:text-sm"
            >
             Designed by Cobby Cobb Digital
            </a>
           
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
